const CookieConsentStyles = theme => ({
  cookieConsentBar: {
    maxWidth: [['initial'], ['!important']]
  },
  consentButton: {
    color: '#ffffff'
  }
});

export default CookieConsentStyles;